// src/ConnectingFlightLeft.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ConnectingFlightLeft_default = createIcon({
  displayName: "ConnectingFlightLeft",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M9.69062 7C8.44659 7 7.25351 7.49419 6.37385 8.37385C5.49419 9.25351 5 10.4466 5 11.6906C5 12.9346 5.49419 14.1277 6.37385 15.0074C7.25351 15.8871 8.44659 16.3812 9.69062 16.3812C10.7626 16.383 11.8028 16.0175 12.6381 15.3456C13.4734 14.6738 14.0534 13.736 14.2814 12.6886H18.9721V11.1916H14.3812C14.2368 10.0445 13.6824 8.98838 12.8203 8.21801C11.9583 7.44764 10.8467 7.01503 9.69062 7ZM9.69062 14.8842C9.26291 14.8976 8.83687 14.8249 8.43781 14.6704C8.03874 14.5159 7.67481 14.2828 7.3676 13.9849C7.06039 13.687 6.81619 13.3304 6.64949 12.9363C6.48279 12.5421 6.397 12.1185 6.39721 11.6906C6.39721 10.8172 6.74419 9.97946 7.36182 9.36182C7.97946 8.74419 8.81715 8.3972 9.69062 8.3972C10.1185 8.397 10.5421 8.48279 10.9363 8.64949C11.3304 8.81619 11.687 9.06039 11.9849 9.3676C12.2828 9.6748 12.5159 10.0387 12.6704 10.4378C12.8249 10.8369 12.8976 11.2629 12.8842 11.6906C12.8842 12.5376 12.5478 13.3499 11.9488 13.9488C11.3499 14.5478 10.5376 14.8842 9.69062 14.8842Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  ConnectingFlightLeft_default
};
